export const notificationOptions = {
  position: ["top", "right"],
  timeOut: 2000,
  showProgressBar:true,
  animate:'fromRight'
};



// WEBPACK FOOTER //
// C:/Users/IsaGul/Desktop/beyn-projects/commercial-front-end/src/app/shared/models/NotificationOptions.ts